import { render, staticRenderFns } from "./CsMenuBadgeIframe.vue?vue&type=template&id=afcafdb8&scoped=true"
import script from "./CsMenuBadgeIframe.vue?vue&type=script&lang=js"
export * from "./CsMenuBadgeIframe.vue?vue&type=script&lang=js"
import style0 from "./CsMenuBadgeIframe.vue?vue&type=style&index=0&id=afcafdb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afcafdb8",
  null
  
)

export default component.exports